import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import sass from '../assets/sass.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import circleDark from '../assets/circleDark.png';
import logo from '../assets/logo.png';

// eslint-disable-next-line
export default {
  email,
  mobile,
  cpp,
  css,
  git,
  html,
  javascript,
  python,
  react,
  sass,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  circleDark,
  logo,
};

// this file will help in easy including of images in our project